
import crud from "./_crud";

const actions = crud('work_shift', 'el turno', 'los turnos');

export default actions